module.exports = __webpack_public_path__ + "img/demo3.10f3ce13.png";